<template>
  <v-select
    v-model="val"
    v-bind="$attrs"
    v-on="$listeners"
    :items="duree"
    item-value="id"
    @input="changed"
    :data-testid="dataTestid"
  />
</template>

<script>
import duree from "@/filters/duree";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: null,
    },
  },

  data() {
    return {
      val: null,
      duree: [
        "JOUR",
        "MOIS",
        "ANNEE"
      ].map(id => ({
        id,
        text: duree(id),
      })),
    };
  },
  mounted() {
    this.syncVal();
  },

  methods: {
    syncVal() {
      this.val = this.value;
    },
    changed() {
      this.$emit("input", this.val);
    },
  },

  watch: {
    value() {
      this.syncVal();
    },
  },
};
</script>
